import * as types from "../mutation-types";
import customer from "@/api/customer";

export const state = {
  customer: {},
};

export const getters = {
  customer: (state) => state.customer,
};

export const mutations = {
  [types.CUSTOMER_SET](state, customer) {
    state.customer = customer;
  },
};

export const actions = {
  async get({ commit, rootGetters }) {
    try {
      commit(types.INCREMENT_REQUEST, undefined, { root: true });

      const data = await customer.get(rootGetters["user/token"]);

      commit(types.CUSTOMER_SET, data);
    } finally {
      commit(types.DECREMENT_REQUEST, undefined, { root: true });
    }
  },

  async changeSettings({ commit, rootGetters }, { payload }) {
    try {
      commit(types.INCREMENT_REQUEST, undefined, { root: true });

      const data = await customer.changeSettings(
        rootGetters["user/token"],
        payload
      );

      commit(types.CUSTOMER_SET, data);
    } finally {
      commit(types.DECREMENT_REQUEST, undefined, { root: true });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
